import PropTypes from "prop-types"
import { RiCloseLine } from "react-icons/ri"

import theme from "@/theme"

import { Button } from "./Button"

/**
 * This component renders a close button with icon and text with specific styles
 *
 * @param {object} props
 * @param {string} [props.text] - The text of the button
 * @param {ReactNode} props.children - The icon of the button
 * @returns {JSX.Element}
 */
export const CloseButton = ({ text, children, ...props }) => {
  const { normal } = theme.iconSizes
  return (
    <Button rounded {...props}>
      {children ?? <RiCloseLine size={normal} />}
      {text}
    </Button>
  )
}

CloseButton.propTypes = {
  /** Defines the text of the button */
  text: PropTypes.string,
  /** Defines the icon of the button */
  children: PropTypes.node,
}
